
  import { Component, Vue } from 'vue-property-decorator'

  @Component
  export default class Error extends Vue {
    public supportEmail = process.env.VUE_APP_SUPPORT_EMAIL
  }
